import React from 'react';

const Avatar = ({ src, name, size = 48, online, verified, style, ring }) => (
  <div style={{ position: 'relative', width: size, height: size, flexShrink: 0, ...style }}>
    {ring && <div style={{
      position: 'absolute', inset: -3, borderRadius: '50%',
      background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)', padding: 2
    }}>
      <div style={{ width: '100%', height: '100%', borderRadius: '50%', background: '#08080C' }} />
    </div>}
    <img
      src={src || `https://ui-avatars.com/api/?name=${name || 'U'}&background=1A1A24&color=FF3D71&bold=true&size=${size * 2}`}
      alt={name || ''}
      onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${name || 'U'}&background=1A1A24&color=FF3D71&bold=true&size=${size * 2}`; }}
      style={{
        width: size, height: size, borderRadius: '50%', objectFit: 'cover',
        border: ring ? 'none' : '2px solid rgba(255,255,255,0.08)',
      }}
    />
    {online && <div style={{
      position: 'absolute', bottom: 1, right: 1,
      width: size * 0.25, height: size * 0.25, minWidth: 10, minHeight: 10,
      background: '#22C55E', borderRadius: '50%',
      border: '2px solid #08080C',
    }} />}
    {verified && <div style={{
      position: 'absolute', bottom: -2, right: -2,
      width: size * 0.3, height: size * 0.3, minWidth: 14, minHeight: 14,
      background: 'linear-gradient(135deg, #3B82F6, #60A5FA)',
      borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
      border: '2px solid #08080C', fontSize: size * 0.15 || 8,
    }}>✓</div>}
  </div>
);

export default Avatar;
